import { navigate, withPrefix } from 'gatsby'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Context } from '../../../context/app-context'
import GameController from '../../../curv-game/SSR-firewall'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import GameQuestionModal from '../../molecules/gameQuestionModal/gameQuestionModal'
import GameVideoModal from '../../molecules/gameVideoModal/gameVideoModal'
import './curvGameContent.scss'

const CurVGameContent = () => {
  const CurVGame = useRef()
  const { dispatch } = useContext(Context)
  const [isActivePreGame, setIsActivePreGame] = useState(false)
  const [questionActive, setQuestionActive] = useState(null)
  const isMobile = useMediaQuery()

  const onFinishVideo = (isVideoComplete = false) => {
    if (!CurVGame.current) {
      let defaultPoints = isVideoComplete ? 6 : 0

      CurVGame.current = (
        <GameController
          isMobile={isMobile}
          defaultPoints={defaultPoints}
          onFinishGame={onFinishGame}
          onShowQuestion={onShowQuestion}
        />
      )

      setIsActivePreGame(null)
    }
  }

  const onShowQuestion = question => {
    localStorage.removeItem('CORRECT_ANSWER')
    localStorage.setItem('IS_PAUSED', true)
    setQuestionActive(question)
  }

  const onCloseQuestion = ({ correctAnswer }) => {
    localStorage.setItem('CORRECT_ANSWER', correctAnswer)
    setQuestionActive(null)
  }

  const onFinishGame = props => {
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'endGame',
        props: {
          modalCorrect: props.isWinner,
          points: props.points,
          close: () => {
            dispatch({ type: 'clear-modal' })
            // navigate('/')
            window.location.href = withPrefix('/')
          },
        },
      },
    })
  }

  useEffect(() => {
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'login',
        props: {
          close: () => {
            navigate('/')
            dispatch({ type: 'clear-modal' })
          },
          handleStartGame: () => setIsActivePreGame(true),
          mobile: isMobile,
        },
      },
    })
  }, [])

  return (
    <div className="f-game-content">
      {isActivePreGame && (
        <GameVideoModal
          onSkipVideo={() => onFinishVideo(false)}
          onFinishVideo={() => onFinishVideo(true)}
        />
      )}

      {questionActive && (
        <GameQuestionModal
          onCloseQuestion={onCloseQuestion}
          questionInfo={questionActive}
        />
      )}

      {CurVGame.current}
    </div>
  )
}

export default CurVGameContent
